<template>
  <wo-card :title="$t('userAccount.contact.title')">
    <wo-properties mod-bordered>
      <wo-properties-label><wo-label v-t="'form.email.label'" /></wo-properties-label>
      <wo-properties-value>
        <po-email-link :value="value.email" />
      </wo-properties-value>
      <wo-properties-label><wo-label v-t="'userAccount.contact.phoneNumber'" /></wo-properties-label>
      <wo-properties-value><po-display :value="value.phone_number" /></wo-properties-value>
    </wo-properties>
  </wo-card>
</template>

<script>

import { User } from '@/model/identity'

export default {
  props: {
    value: User,
    adminMode: Boolean
  }
}
</script>
